import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ScoreForm } from '../components/ScoreForm';
import moment from 'moment';
import { ReviewInfo } from '../components/ReviewInfo';

export const ScoreFormView = () => {
    const [formState, setFormState] = useState({
        view: 'form',
        initialValues: {
            primerNombre: '',
            segundoNombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            email: '',
            fechaNacimiento: '',
            direccion1: '',
            coloniaPoblacion: '',
            cp: '',
            delegacionMunicipio: '',
            estado: '',
            ciudad: '',
        },
    });

    const { view, initialValues } = formState;

    const [currentDateTime, setCurrentDateTime] = useState(
        moment().format('DD [de] MMMM [del] YYYY HH:mm:ss a')
    );

    useEffect(() => {
        const interval = setInterval(
            () =>
                setCurrentDateTime(
                    moment().format('DD [de] MMMM [del] YYYY HH:mm:ss a')
                ),
            1000
        );

        return () => clearInterval(interval);
    }, []);

    return (
        <Box>
            <Typography
                variant="body1"
                sx={{
                    position: 'absolute',
                    top: 10,
                    right: 20,
                    fontSize: 12,
                    textTransform: 'capitalize',
                }}
            >
                {currentDateTime}
            </Typography>
            {view === 'form' ? (
                <ScoreForm
                    initialValues={initialValues}
                    setFormState={setFormState}
                />
            ) : (
                <ReviewInfo
                    initialValues={initialValues}
                    setFormState={setFormState}
                />
            )}
        </Box>
    );
};
